<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template slot="title">
          <strong>三咖音乐代理创建</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-22 fw-700" @click="$router.replace('/agent/generate-agent')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="form">
      <div class="form-item">
        <div class="label">手机号码</div>
        <div class="input"><input :value="phone" disabled type="number" maxlength="11" placeholder="请输入要绑定的代理的手机号码"></div>
      </div>
      <div class="form-item">
        <div class="label">代理类型</div>
        <div class="select" :class="{ 'active': group_id && true || false }" @click="isDisabledGroupId ? null : openSelect('group_id')">
          <span v-if="!group_id">请选择代理类型</span>
          <span v-else>{{ group_id }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="label">代理简称</div>
        <div class="input"><input v-model="name" type="text" placeholder="请输入代理简称"></div>
      </div>
      <div class="form-item">
        <div class="label">个人/企业</div>
        <div class="input"><input v-model="full_name" :disabled="isDisabledFullName" type="text" placeholder="请输入个人/企业"></div>
      </div>
      <div class="form-item">
        <div class="label">代理性质</div>
        <div class="select" :class="{ 'active': property && true || false }" @click="openSelect('property')">
          <span v-if="!property">请选择代理性质</span>
          <span v-else>{{ property }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="label">联系人</div>
        <div class="input"><input v-model="link_man" type="text" placeholder="请输入联系人"></div>
      </div>
      <van-button :loading="loading" color="#FC3159" class="login-btn mt-24 border-radius" loading-text="加载中..." @click="generateAgentQr">生成二维码</van-button>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { getGenerateAgentProperty, generateAgentQr } from '@/api/agent.js'
const groupIdIndex = {
  company: '企业',
  person: '个人'
}
export default {
  name: 'GenerateAgent',
  data() {
    return {
      loading: false,
      group_id: '', // 1 个人 2 企业
      user_id: '', // 校验结果ID
      link_man: '', // 认证名称
      name: '', // 代理简称
      full_name: '', // 艺人/公司名称
      isDisabledFullName: false, // 艺人/公司名称是否禁止使用，接口返回值就禁止，不返回值不禁止
      isDisabledGroupId: false, // 代理类型是否禁止使用，接口返回值就禁止，否则不禁止
      property: '', // 代理性质
      phone: '', // 电话号码
      rePhone: '', // 再次输入的手机号码
      show: false,
      curKey: '',
      propertyIndex: {}, // 代理性质索引
      actions: []
    }
  },
  computed: {
    groupType() {
      return [{ name: '个人', color: this.group_id === '个人' && '#0079FF' || '' }, { name: '企业', color: this.group_id === '企业' && '#0079FF' || '' }]
    },
    propertyType() {
      return Object.keys(this.propertyIndex).map(val => ({
        name: val,
        color: this.property === val && '#0079FF' || ''
      }))
    }
  },
  async activated() {
    this.$store.commit('TOGGLE_LOADING', true)
    const info = JSON.parse(localStorage.getItem('generateAgentUsreInfo'))
    this.phone = info.phone
    this.full_name = info.real_name
    this.isDisabledFullName = info.real_name ? true : false
    this.name = info.nickname
    this.user_id = info.uid
    this.group_id = groupIdIndex[info.real_type]
    this.isDisabledGroupId = info.real_type ? true : false
    await this.getGenerateAgentProperty()
    this.$store.commit('TOGGLE_LOADING', false)
  },
  methods: {
    openSelect(type) {
      this.curKey = type
      this.actions = type === 'group_id' ? this.groupType : this.propertyType
      this.show = true
    },
    onSelect(evt) {
      this[this.curKey] = evt.name
      this.show = false
    },
    async getGenerateAgentProperty() {
      const res = await getGenerateAgentProperty({})
      this.propertyIndex = res.data
    },
    async generateAgentQr() {
      const { group_id, link_man, full_name, property, phone, user_id, name } = this
      const params = {
        group_id: group_id === '个人' ? 1 : 2,
        link_man,
        full_name,
        property,
        phone,
        user_id,
        name
      }
      this.loading = true
      try {
        const res = await generateAgentQr(params)
        if (res.code === 1) {
          this.$router.push({
            path: '/agent/generate-res',
            query: {
              url: encodeURI(res.data)
            }
          })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  margin-top: 0;
  .form-item{
    .input{
      color: #222;
    }
  }
}
</style>
